/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SecureValue/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Simple/Data/validate.js'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SecureValue({
  children,
  viewPath = "/App/Account/Content/Settings/Content/SecureValue",
  onChange,
  isInvalid,
  isInvalidInitial
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let selectedValueValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'value',
})
let selectedValueIsValidData = fromData.useDataIsValid({ viewPath,
context: 'selected',
path: 'value',
validate: fromValidate.textAtLeastTwoChars,
required: true,
})
let selectedValueChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'value',
})
let selectedValueValueData1 = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'value',
})
let selectedValueIsValidInitialData = fromData.useDataIsValidInitial({ viewPath,
context: 'selected',
path: 'value',
validate: fromValidate.textAtLeastTwoChars,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onChange,
  isInvalid,
  isInvalidInitial
  
})
let selectedSecureValueValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'secure_value',
})
let selectedSecureValueValueData1 = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'secure_value',
})
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="SecureValue.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-Z1r6xj0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-2-Z1r6xj0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Create a secure value to share with the Greyfinch support team"
/>
<div
  data-testid="SecureValue.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="text"
 autoFocus={true}
 data="selected.value"
 validate="/Simple/Data/validate.js textAtLeastTwoChars"
 required={true}
 onChange={selectedValueChangeData}
 value={selectedValueValueData}
 invalid={!selectedValueIsValidData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Raw value"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 alignSelf="auto"
 marginLeft={dtSpaceXs}
 data="selected.value"
 validate="/Simple/Data/validate.js textAtLeastTwoChars"
 value={selectedValueValueData1}
 disabled={!selectedValueIsValidInitialData}
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Secure!"
/>
)}
</TysiaButton>
</div>
<fromFlow.When is={selectedSecureValueValueData}>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="selected.secure_value"
 type="text"
 data="selected.secure_value"
 disabled={true}
 value={selectedSecureValueValueData1}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Secure value"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}